import { Injectable } from "@angular/core";
import { CrudService } from "app/shared/crud-service";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { TipoDespesaDTO } from '../models/tipo-despesa.model';

@Injectable({
    providedIn: "root"
})
export class TiposDespesaService extends CrudService<TipoDespesaDTO> implements Resolve<any>{
    routeParams: any;

    constructor(protected http: HttpClient) {
        super(http, `${environment.apiUrlRDV}/v1/tipo-despesa-viagem`);
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;
        if (this.routeParams.id === "new") {
            return new Promise((resolve, reject) => {
                this.onDataChanged.next(false);
                resolve(false);
            });
        } else {
            return this.getById(this.routeParams.id);
        }
    }

}